import { render, staticRenderFns } from "./secondaryButton.vue?vue&type=template&id=6fb44e7a&"
import script from "./secondaryButton.vue?vue&type=script&lang=js&"
export * from "./secondaryButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports